function isJsonBody(body) {
  return (
    body !== null &&
    typeof body === "object" &&
    !(body instanceof FormData) &&
    !(body instanceof Blob) &&
    !(body instanceof URLSearchParams)
  );
}

async function parseResponse(response) {
  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
}

async function request(url, config = {}) {
  const headers = { ...(config.headers || {}) };
  let body = config.body;

  if (isJsonBody(body)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
    body = JSON.stringify(body);
  }

  const response = await fetch(url, {
    method: config.method || "GET",
    headers,
    body,
  });

  const data = await parseResponse(response);
  const result = {
    data,
    status: response.status,
    statusText: response.statusText,
    headers: Object.fromEntries(response.headers.entries()),
    ok: response.ok,
  };

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.response = result;
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return result;
}

const http = {
  get(url, config) {
    return request(url, { ...config, method: "GET" });
  },

  post(url, data, config) {
    return request(url, { ...config, method: "POST", body: data });
  },

  put(url, data, config) {
    return request(url, { ...config, method: "PUT", body: data });
  },

  patch(url, data, config) {
    return request(url, { ...config, method: "PATCH", body: data });
  },

  delete(url, config) {
    return request(url, { ...config, method: "DELETE" });
  },
};

export default http;
